import { render } from "./login-dingtalk.html?vue&type=template&id=5d48f488&scoped=true&ts=true"
import script from "./login-dingtalk.ts?vue&type=script&lang=ts"
export * from "./login-dingtalk.ts?vue&type=script&lang=ts"

import "./login-dingtalk.scss?vue&type=style&index=0&id=5d48f488&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d48f488"]])

export default __exports__